import {
  BarChart3,
  Bell,
  CalendarDays,
  ClipboardList,
  Contact,
  DoorOpen,
  FileText,
  Filter,
  LayoutDashboard,
  LifeBuoy,
  ListChecks,
  Music,
  ScanLine,
  Settings,
  Sparkles,
  UserCog,
  Users,
  UsersRound,
  Workflow,
  type LucideIcon,
} from 'lucide-react'

export type NavItem = {
  label: string
  to: string
  icon: LucideIcon
  /** Permission key gating visibility (enforced server-side too). */
  permission?: string
}

export type NavSection = {
  title: string
  items: NavItem[]
}

/** Sidebar navigation, organized to mirror the Org data hierarchy. */
export const navSections: NavSection[] = [
  {
    title: 'Overview',
    items: [
      { label: 'Dashboard', to: '/app', icon: LayoutDashboard },
      { label: 'Reports', to: '/app/reports', icon: BarChart3, permission: 'reports.read' },
      {
        label: 'Notifications',
        to: '/app/notifications',
        icon: Bell,
        permission: 'notifications.read',
      },
    ],
  },
  {
    title: 'People',
    items: [
      { label: 'People', to: '/app/people', icon: Users, permission: 'people.read' },
      { label: 'Directory', to: '/app/directory', icon: Contact, permission: 'people.read' },
      { label: 'Groups', to: '/app/groups', icon: UsersRound, permission: 'groups.read' },
      { label: 'Lists', to: '/app/lists', icon: Filter, permission: 'lists.read' },
    ],
  },
  {
    title: 'Ministry',
    items: [
      { label: 'Teams', to: '/app/teams', icon: ListChecks, permission: 'teams.read' },
      { label: 'Events', to: '/app/events', icon: CalendarDays, permission: 'events.read' },
      { label: 'Calendar', to: '/app/calendar', icon: CalendarDays, permission: 'calendar.read' },
      { label: 'Resources', to: '/app/resources', icon: DoorOpen, permission: 'resources.read' },
      { label: 'Check-in', to: '/app/checkins', icon: ScanLine, permission: 'checkins.read' },
      {
        label: 'Service Planning',
        to: '/app/service-planning',
        icon: Music,
        permission: 'services.read',
      },
    ],
  },
  {
    title: 'Automation',
    items: [
      { label: 'Forms', to: '/app/forms', icon: ClipboardList, permission: 'forms.read' },
      { label: 'Workflows', to: '/app/workflows', icon: Workflow, permission: 'workflows.read' },
      { label: 'AI assist', to: '/app/ai', icon: Sparkles, permission: 'ai.use' },
    ],
  },
  {
    title: 'Content',
    items: [{ label: 'Content', to: '/app/content', icon: FileText, permission: 'content.read' }],
  },
  {
    title: 'Administration',
    items: [
      { label: 'Members', to: '/app/members', icon: UserCog, permission: 'members.read' },
      { label: 'Support', to: '/app/support', icon: LifeBuoy, permission: 'support.view' },
      { label: 'Settings', to: '/app/settings', icon: Settings, permission: 'settings.read' },
    ],
  },
]
